/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2023-02-20 13:38:30
 * @LastEditors: suzhen suzhen@dianzhong.com
 * @LastEditTime: 2024-04-18 13:35:25
 * @Description  : 用户信息缓存
 */
import { removeUserId, setUserId, getUserId, setUserNum } from '@/utils/cookie'
import request from '../../utils/request'
const user = {
    state: {
        token: getUserId(),
        mobile: '',
        admin_id: '', // 抖音邀请码绑定
        userId: '',
        teamSlefInviteCode: '',
        account_list: [], // 用户绑定的邀请码
        hasKsandmi: false,
        userAccount:{},
        company_list: [],
        teamLeaderBenefit: '',
        filter_list: {},
        media_list: [],
        no_see_count: 0, // 用户未读消息条数
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token || ''
        },
      
        SET_USER: (state, user) => {
            if(user.fix_mobile) state.mobile = user.fix_mobile || ''
            if(user.admin_id) state.admin_id = user.admin_id || ''
            if(user.id) state.userId = user.id
            state.teamSlefInviteCode = user.team_leader_invite_code
            if(user.accountList) {
                state.account_list = user.accountList
                let ksa = user.accountList.find(item => item.videoType == 3) || ''
                state.hasKsandmi = ksa ? true : false                // 3是快手
            }
            if (user.team_leader_benefit) {
                state.teamLeaderBenefit = `${+user.team_leader_benefit * 100}%`
            }
            if (user.filter_list) state.filter_list = user.filter_list
            state.userAccount.name=user.name                         // 用户姓名
           
            state.userAccount.all_type_withdraw = user.all_type_withdraw

            state.userAccount.bank_card = user.bank_card             // 用户账号
            state.userAccount.platform_pay = user.platform_pay
            state.company_list = user.company_list                   // 公司列表
            state.media_list = user.media_list                       // 媒体列表
            // 用户收入金额
            // if(user.freeze_money_benefit !== undefined) {
            state.userAccount.freeze_money_benefit = user.freeze_money_benefit  // 冻结中
            state.userAccount.money = user.money_benefit                        // 可提现
            state.userAccount.withdrew_balance = user.withdrew_balance          // 已提现
            state.userAccount.withdrawing_balance = user.withdrawing_balance    // 提现中
            
            
            state.userAccount.ad_money_benefit = user.ad_money_benefit              // 可提现 
            state.userAccount.ad_withdrawing_balance = user.ad_withdrawing_balance  // 提现中
            state.userAccount.ad_freeze_money = user.ad_freeze_money                // 冻结中
            state.userAccount.ad_pretax_withdrew_balance = user.ad_pretax_withdrew_balance        //已提现
            // }
            state.userAccount.pay_type= user.pay_type  // 1:对私 2：对公

            state.no_see_count= user.notice?.no_see_count || 0  // 未读消息条数
        },

        SET_NO_SEE_COUNT: (state, user)=>{
            state.no_see_count= user.no_see_count || 0  // 未读消息条数
        },

        RESET_USER: (state) => {
            state.token = null
            state.mobile = null
            state.admin_id = null
            state.teamSlefInviteCode = ''
            state.account_list = []
            state.hasKsandmi = false
        }
    },
    actions: {
        // 登录  只获取token
        Login({ commit }, loginForm) {
            return new Promise((resolve, reject) => {
                request.post('v1/Koc/login',loginForm).then(response => {
                    if (response && response.token) {
                        // cookie中保存token
                        setUserId(response.token)
                        commit('SET_TOKEN', response.token)
                    }
                    resolve(response)
                },(err)=>{
                    reject(err)
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            })
        },
        // 获取用户信息  根据token获取用户信息
        GetUserInfo({ commit }) {
            return new Promise((resolve, reject) => {
                request.post('/v1/Koc/user',{}).then(response => {
                    if (response) commit('SET_USER', response)
                    setUserNum(response.id)
                    resolve(response)
                },(err)=>{
                    reject(err)
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            })
        },
  
        // 登出
        Logout({ commit }) {
            return new Promise((resolve, reject) => {
                request.post('v1/Koc/logout', {}).then((res) => {
                    // 清除token等相关角色信息
                    removeUserId()
                    commit('RESET_USER')
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}
export default user